import React from 'react';

import {Col, Row} from 'reactstrap';

import PropTypes from 'prop-types';
import PublicCompaniesItem from './PublicCompaniesItem';

class PublicCompanies extends React.Component {
  static defaultProps = {
    grid: {
      lg: 12,
    },
    companies: [],
  };

  static propTypes = {
    grid: PropTypes.object,
    companies: PropTypes.array,
  };

  render() {
    const {grid, companyType, companies} = this.props;

    return (
      <Row tag="ul" className="mb-0">
        {companies.map((item, index) => {
          return (
            <Col key={index} tag="li" className="mb-3" {...grid}>
              <PublicCompaniesItem
                companyType={companyType}
                to={item.to}
                file={item.file}
                countryName={item.countryName}
                companyName={item.companyName}
                companyAcronym={item.companyAcronym}
              />
            </Col>
          );
        })}
      </Row>
    );
  }
}

export default PublicCompanies;
